import React from 'react';
import Demographics from './Demographics';
import postData from '../API';

import getConfig from '../../../config';

class DemographicsPage extends React.Component {
  componentDidMount = async () => {
    const { updateContext, campaign, rut } = this.props;
    // const { rut } = this.state;
    if (updateContext) {
      // console.log('on test');
      // console.log({ props: this.props });
      if (rut) {
        const { USER_ID, USER_STAGE, CURRENT_CODE } = await getConfig(
          campaign.id,
          rut
        );
        await updateContext({
          user: USER_ID,
          stage: USER_STAGE,
          rut: CURRENT_CODE
        });
      } else {
        const { USER_ID, USER_STAGE } = await getConfig(campaign.id);
        await updateContext({
          user: USER_ID,
          stage: USER_STAGE
        });
      }
    }
  };

  onComplete = async data => {
    const { campaign, rut, user, stage = 0 } = this.props;
    // const { rut } = this.state;
    const userData = {
      ...user
    };
    let finished = { finished: 0 };
    if (this.props.isLast) {
      finished.finished = 1;
    }

    const newData = {
      ...userData,
      ...data,
      ...finished,
      userData,
      campaignData: campaign,
      VERSION: '1.0',
      RUT: rut,
      STAGE: stage + 1
    };

    // set SEX value on local storage
    // console.log({ SEX: data.SEX });
    if (data.SEX) {
      localStorage.setItem(`current-${rut}-SEX`, data.SEX);
    }

    // if parent has onComplete
    if (this.props.onComplete) {
      return this.props.onComplete(newData);
    }

    const { USER_ID } = await getConfig(campaign.id, rut);
    return postData(newData, USER_ID, rut);
  };

  render() {
    return (
      <Demographics
        onComplete={this.onComplete}
        initialData={this.props.user}
      />
    );
  }
}

export default DemographicsPage;
